import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class LuotettavaKumppani extends MeasurIcon<
  SVGProps<SVGSVGElement>
> {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="132"
        height="66"
        viewBox="0 0 792 392.864"
      >
        <defs>
          <path id="a" d="M.04.7V0h.121v.7H.04Z" />
          <path
            id="b"
            d="M.043.493V.234c0-.153.086-.242.204-.242a.22.22 0 0 1 .167.074L.422 0h.109v.494H.41V.241C.41.166.359.103.284.103.206.103.165.16.165.235v.258H.043Z"
          />
          <path
            id="c"
            d="M.272.504A.247.247 0 0 1 .017.246c0-.142.096-.257.256-.257S.53.104.53.246a.25.25 0 0 1-.258.258M.273.393C.355.393.407.32.407.246.407.171.362.101.273.101c-.089 0-.134.07-.134.145 0 .074.046.147.134.147Z"
          />
          <path
            id="d"
            d="M.09.619V.492h-.092V.387H.09V.174c0-.123.07-.184.177-.18a.272.272 0 0 1 .101.021L.334.12A.14.14 0 0 0 .275.104c-.038 0-.064.023-.064.07v.213h.137v.105H.212v.14L.09.619Z"
          />
          <path
            id="e"
            d="M.529.203C.548.406.445.508.28.508.12.508.018.4.018.25c0-.158.101-.263.271-.263.075 0 .16.026.212.08L.423.144C.395.115.336.098.291.098.205.098.152.142.144.203h.385M.146.304C.164.368.218.4.284.4.354.4.404.368.412.304H.146Z"
          />
          <path
            id="f"
            d="M.427.425C.399.474.336.505.27.505.126.505.013.417.013.247c0-.173.108-.263.254-.262.055 0 .132.029.16.087L.433 0h.115v.493H.431L.427.425M.281.396c.192 0 .192-.299 0-.299C.2.097.135.153.135.247s.065.15.146.15Z"
          />
          <path
            id="g"
            d="M.418.494.35.33.275.123.199.331.131.494h-.133l.211-.496h.132l.21.496H.418Z"
          />
          <path
            id="h"
            d="M.037.7V0h.122v.223L.352 0h.147v.009L.27.261l.201.225v.007H.325L.159.295V.7H.037Z"
          />
          <path
            id="i"
            d="M.49 0v.264c0 .065.041.122.107.122S.69.331.69.266V0h.122v.266C.812.414.743.5.603.5A.179.179 0 0 1 .438.41C.41.478.351.502.292.502.245.502.188.484.162.434l-.009.06H.04V0h.122v.264c0 .065.039.124.105.124C.334.388.368.33.368.264V0H.49Z"
          />
          <path
            id="j"
            d="M.313.106a.137.137 0 0 0-.14.14c0 .077.052.14.14.14.088 0 .14-.063.14-.14a.137.137 0 0 0-.14-.14M.162-.206v.264c.035-.054.112-.07.164-.07.158 0 .249.114.249.258 0 .145-.101.258-.253.258a.196.196 0 0 1-.16-.08l-.008.07H.04v-.7h.122Z"
          />
          <path
            id="k"
            d="M.525 0v.259c0 .155-.093.242-.209.242A.222.222 0 0 1 .154.427L.146.494H.037V0h.121v.252c0 .075.051.138.126.138C.362.39.403.333.403.258V0h.122Z"
          />
          <path
            id="l"
            d="M.162.495V0H.04v.495h.122M.029.632c0-.095.144-.095.144 0s-.144.095-.144 0Z"
          />
          <path
            id="m"
            d="M.457.716C.226.716.096.55.096.351c0-.198.13-.365.361-.365.232 0 .362.167.362.365 0 .198-.13.365-.362.365M.202.351c.001.151.093.27.255.27.163 0 .255-.119.255-.27 0-.15-.092-.27-.255-.27-.162 0-.254.12-.255.27M.635.19V.168H.531L.444.282H.41V.168H.313v.367h.175C.65.535.677.331.544.301L.635.19M.41.45V.363h.078c.057 0 .057.084 0 .084H.41Z"
          />
        </defs>
        <path d="M0 392.864h792V0H0Z" fill="#0a9b5e" />
        <use
          data-text="l"
          xlinkHref="#a"
          transform="matrix(123.298 0 0 -123.298 85.655 181.002)"
          fill="#fff"
        />
        <use
          data-text="u"
          xlinkHref="#b"
          transform="matrix(123.298 0 0 -123.298 113.767 181.002)"
          fill="#fff"
        />
        <use
          data-text="o"
          xlinkHref="#c"
          transform="matrix(123.298 0 0 -123.298 187.622 181.002)"
          fill="#fff"
        />
        <use
          data-text="t"
          xlinkHref="#d"
          transform="matrix(123.298 0 0 -123.298 257.162 181.002)"
          fill="#fff"
        />
        <use
          data-text="e"
          xlinkHref="#e"
          transform="matrix(123.298 0 0 -123.298 306.358 181.002)"
          fill="#fff"
        />
        <use
          data-text="t"
          xlinkHref="#d"
          transform="matrix(123.298 0 0 -123.298 375.652 181.002)"
          fill="#fff"
        />
        <use
          data-text="t"
          xlinkHref="#d"
          transform="matrix(123.298 0 0 -123.298 418.806 181.002)"
          fill="#fff"
        />
        <use
          data-text="a"
          xlinkHref="#f"
          transform="matrix(123.298 0 0 -123.298 461.96 181.002)"
          fill="#fff"
        />
        <use
          data-text="v"
          xlinkHref="#g"
          transform="matrix(123.298 0 0 -123.298 533.473 181.002)"
          fill="#fff"
        />
        <use
          data-text="a"
          xlinkHref="#f"
          transform="matrix(123.298 0 0 -123.298 603.753 181.002)"
          fill="#fff"
        />
        <use
          data-text="k"
          xlinkHref="#h"
          transform="matrix(123.298 0 0 -123.298 86.148 281.736)"
          fill="#fff"
        />
        <use
          data-text="u"
          xlinkHref="#b"
          transform="matrix(123.298 0 0 -123.298 152.112 281.736)"
          fill="#fff"
        />
        <use
          data-text="m"
          xlinkHref="#i"
          transform="matrix(123.298 0 0 -123.298 228.434 281.736)"
          fill="#fff"
        />
        <use
          data-text="p"
          xlinkHref="#j"
          transform="matrix(123.298 0 0 -123.298 340.142 281.736)"
          fill="#fff"
        />
        <use
          data-text="p"
          xlinkHref="#j"
          transform="matrix(123.298 0 0 -123.298 419.67 281.736)"
          fill="#fff"
        />
        <use
          data-text="a"
          xlinkHref="#f"
          transform="matrix(123.298 0 0 -123.298 499.196 281.736)"
          fill="#fff"
        />
        <use
          data-text="n"
          xlinkHref="#k"
          transform="matrix(123.298 0 0 -123.298 576.997 281.736)"
          fill="#fff"
        />
        <use
          data-text="i"
          xlinkHref="#l"
          transform="matrix(123.298 0 0 -123.298 652.21 281.736)"
          fill="#fff"
        />
        <use
          data-text="®"
          xlinkHref="#m"
          transform="matrix(36 0 0 -36 679.3 220.909)"
          fill="#fff"
        />
      </svg>
    )
  }
}
